var React = require('react');

function SoundOff (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M13.2,20.5h6.6l10.3-6.8V40l-10.3-6.8h-6.6c-1.1,0-2-0.9-2-2v-8.8C11.2,21.3,12.1,20.5,13.2,20.5z"})),React.createElement("line",{"className":"st0","x1":"35.6","y1":"13.5","x2":"9.6","y2":"39.5","key":2})]);
}

SoundOff.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 53.6 53.6","style":{"enableBackground":"new 0 0 53.6 53.6"},"xmlSpace":"preserve"};

module.exports = SoundOff;

SoundOff.default = SoundOff;
